// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"ba8e2d8fdecea23c2c11","113":"e9b03d3f5c58b5523423","114":"a4f97097c00c885bf403","161":"e9d8e20ece4cdf1c42c4"}[chunkId] + ".chunk.js";
};